export default "__VITE_ASSET__538fd5b8__"